import { SET_SESSION_ID, CLEAR_SESSION_ID } from "./types";

export const setSessionId = (sessionId) => ({
    type: SET_SESSION_ID,
    payload: sessionId,
});

export const clearSessionId = () => ({
    type: CLEAR_SESSION_ID,
});